var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    staticClass: "btn-xs d-flex align-items-center",
    class: _vm.type,
    on: {
      "click": _vm.handleOpen
    }
  }, [_c('small', [_vm._v("Download")]), _vm._v(" "), _c('i', {
    staticClass: "ri-download-2-line ml-1"
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }